import { Section, stateWord, AURORA_BAR } from "./primitives";

export const ComponentBreakdown = ({ components, methodology, value }: {
  components: any[]; methodology: any; value: number | null;
}) => {
  const weights = methodology?.weights || [];
  const contribs = components.filter((c) => c.contribution != null);
  return (
    <Section num="05" title="Component Breakdown" sub="Canonical backend weights" testid="li-breakdown-section">
      {weights.length > 0 && (
        <div className="rounded-lg border border-white/[0.08] bg-white/[0.02] px-4 py-3 nl-mono text-[11px] sm:text-[12px] text-gray-300 overflow-x-auto whitespace-nowrap"
          data-testid="li-formula">
          <span className="text-[#A78BFA] font-bold">Layer Index</span>
          {" = "}
          {weights.map((w: any, i: number) => (
            <span key={w.key}>
              {i > 0 && "  +  "}
              {(w.weight / 100).toFixed(2)} × <span className="text-white">{w.name}</span>
            </span>
          ))}
        </div>
      )}
      <div className="grid md:grid-cols-3 gap-5 mt-6">
        {components.map((c) => {
          const [word, wcolor] = stateWord(c.score);
          return (
            <div key={c.key} className="rounded-xl border border-white/[0.08] bg-[#0b0c10] p-5"
              data-testid={`li-breakdown-${c.key}`}>
              <div className="flex items-baseline justify-between gap-2">
                <p className="font-semibold text-white text-[14px]">{c.name}</p>
                <span className="nl-mono text-[9px] uppercase tracking-[0.18em] text-gray-600 shrink-0">
                  {c.weight}%
                </span>
              </div>
              <div className="flex items-baseline gap-2.5 mt-3">
                <span className="nl-sg text-3xl font-bold text-white">
                  {c.score != null ? Math.round(c.score) : "—"}
                </span>
                <span className="nl-mono text-[10px] font-bold uppercase" style={{ color: wcolor }}>{word}</span>
              </div>
              <div className="mt-3 h-1 rounded-full bg-white/[0.05] overflow-hidden">
                <div className="h-full rounded-full"
                  style={{ width: `${Math.max(0, Math.min(c.score ?? 0, 100))}%`, background: AURORA_BAR }} />
              </div>
              <p className="nl-mono text-[10.5px] text-gray-400 mt-3">
                <span className="text-[#00E5FF] font-bold">{c.contribution ?? "—"}</span> of {c.weight} possible pts
              </p>
              <p className="text-[12px] text-gray-500 leading-relaxed mt-2">{c.detail}</p>
            </div>
          );
        })}
      </div>
      {contribs.length === components.length && value != null && (
        <p className="nl-mono text-[10px] text-gray-600 mt-4" data-testid="li-breakdown-sum">
          Weighted contributions: {contribs.map((c) => c.contribution).join(" + ")} ≈ {value}/100
        </p>
      )}
    </Section>
  );
};
